import { seedModule } from "./seed";
import type { ModuleNode } from "./types";
import { allModules } from "./modules/index";
import { navDB } from "./db";

export async function initSearch() {
   await resetModules(allModules);
}

export async function resetModules(modules: ModuleNode[]) {
  // Clear everything from IndexedDB
  await navDB.transaction("readwrite", navDB.navNodes, navDB.navItems, async () => {
    await navDB.navNodes.clear();
    await navDB.navItems.clear();
  });

  // Reseed all modules
  for (const module of modules) {    
    await seedModule(module);
  }
}
